import * as s from "./website-black-allie-simple.scss";
import {Component} from "../../../../../../../sedestral/framework/interface/component/Component";
import {Resources} from "../../../../../../../resources/Resources";

export class ComponentWebsiteBlackAllieSimple extends Component {
    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackAllieSimple}">
                <div class="${s.cases}">
                    <div class="${s.case} ${s.google}">
                        <h3 class="${s.name}">
                            <span class="${s.goog}"></span> ${Resources.t("words.googleLikesUpdatedContent")}
                        </h3>
                        <p class="${s.description}">
                            ${Resources.t("words.updatePagesWithTopContent")}
                        </p>
                    </div>
                    <div class="${s.case}">
                        <div class="${s.icon} ${s.ai}"></div>
                        <h3 class="${s.name}">
                            ${Resources.t("words.effortlessContentUpdate")}
                        </h3>
                        <p class="${s.description}">
                            ${Resources.t("words.contentAuditToOptimize")}
                        </p>
                    </div>
                    <div class="${s.case}">
                        <div class="${s.icon} ${s.refresh}"></div>
                        <h3 class="${s.name}">
                            ${Resources.t("words.outperformCompetitors")}
                        </h3>
                        <p class="${s.description}">
                            ${Resources.t("words.keepContentFresh")}
                        </p>
                    </div>
                </div>
            </div>
        `;
    }

}
